var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "emd-modal _size_large _active",
      staticStyle: { "z-index": "10000" },
    },
    [
      _c("div", { staticClass: "emd-modal__content" }, [
        _c(
          "div",
          { staticClass: "emd-container _header_end _header_auto _footer_end" },
          [
            _c(
              "div",
              { staticClass: "emd-container__header eu-justify_end_mobile" },
              [
                _c(
                  "button",
                  {
                    staticClass: "emd-btn _type_link",
                    on: { click: _vm.closeModal },
                  },
                  [_c("i", { staticClass: "uil uil-times" })]
                ),
              ]
            ),
            _c("div", { staticClass: "emd-container__content eu-pa_4" }, [
              this.steps.header.show && this.steps.header.isActive
                ? _c("div", { attrs: { id: "onboarding-step-1" } }, [
                    _c("div", { staticClass: "eu-flex-item eu-align_center" }, [
                      _c(
                        "div",
                        { staticClass: "eu-display_none eu-display_block_md" },
                        [
                          _c("img", {
                            staticClass: "eu-mb_4",
                            attrs: {
                              alt: "header dash",
                              src: _vm.new_header_dash,
                            },
                          }),
                        ]
                      ),
                      _c(
                        "h2",
                        {
                          staticClass:
                            "emd-text _size_section _type_hint _color_contrast",
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("header.title")) + " ")]
                      ),
                      _c("div", { staticClass: "emd-text eu-mt_5" }, [
                        _vm._v(" " + _vm._s(_vm.$t("header.text")) + " "),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              this.steps.home.show && this.steps.home.isActive
                ? _c("div", { attrs: { id: "onboarding-step-2" } }, [
                    _c("div", { staticClass: "eu-flex eu-column eu-row_md" }, [
                      _c("div", { staticClass: "eu-flex-item" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _size_section _type_hint _color_contrast",
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("home.title")) + " ")]
                        ),
                        _c(
                          "p",
                          { staticClass: "emd-text _color_default eu-my_4" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("home.paragraph-1")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "emd-text _color_default eu-my_4" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("home.paragraph-2")) + " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "emd-container__footer" }, [
              this.steps.header.show && this.steps.home.show
                ? _c(
                    "button",
                    {
                      staticClass: "emd-btn _color_primary _type_text",
                      class: { _disabled: _vm.showHeaderStep },
                      on: { click: _vm.previousStep },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("previous")) + " ")]
                  )
                : _vm._e(),
              _vm.showHeaderStep
                ? _c(
                    "button",
                    {
                      staticClass: "emd-btn _color_primary",
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("next")) + " ")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "emd-btn _color_primary",
                      on: { click: _vm.closeModal },
                    },
                    [_vm._v(" ok ")]
                  ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }